<template>
  <div>
    <div ref="DataStatuspop" class="exportBigQuryPopupWrapper" v-show="dspopup">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modelpopContainer exportBigQuryPopup">
            <a class="close-btn" @click="closeexportBigQuryPopup()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
            <div class="clearfix">
              <div class="stepsheading expotbgheading">Data Source(s)</div>
              <table>
                <tr>
                  <th>Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th class="DsStatus">Status</th>
                </tr>
                <tr v-for="(dataStatus, key) in dataStatusPopData" :key="key">
                  <td>{{dataStatus.name}}</td>
                  <td>{{dataStatus.start_date}}</td>
                  <td>{{dataStatus.end_date}}</td>
                  <td class="DsStatus">
                    <i
                      v-if="dataStatus.status === true"
                      class="fa fa-check-circle green"
                      aria-hidden="true"
                    ></i>
                    <i
                      v-if="dataStatus.status === false"
                      class="fa fa-exclamation-circle red"
                      aria-hidden="true"
                    ></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <vue-good-table
        ref="datatransferstatus"
        @on-sort-change="onSortChange"
        mode="local"
        styleClass="table table-bordered condensed"
        :columns="columns"
        :rows="rows"
        :paginate="false"
        :lineNumbers="true"
        :perPage="22"
        :sortable="true"
        :globalSearch="false"
        name="test"
        :sort-options="{enabled: false}"
      >
        <template slot="loadingContent">
          <span class="vgt-loading__content">
            <div class="dataspinner">
              <span>Loading Data</span>
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </span>
        </template>
        <template slot="table-row" slot-scope="props">
          <div class="td-wrapper">
            <div class="statusLoader" v-if="props.column.field == 'Global_Data_Status'">
              <a class="btn btn-sm" @click="openDtdetails(props.row, $event)">
                <i
                  v-if="props.formattedRow[props.column.field] === 'Partial'"
                  class="fa fa-check-circle yellow"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="props.formattedRow[props.column.field] === 'Completed'"
                  class="fa fa-check-circle green"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="props.formattedRow[props.column.field] === 'Failed'"
                  class="fa fa-exclamation-circle red"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="props.formattedRow[props.column.field] === 'In-Progress'"
                  class="fa fa-spinner green"
                  aria-hidden="true"
                ></i>
                <i
                  v-if="props.formattedRow[props.column.field] === 'Etl-Failed'"
                  class="fa fa-exclamation-circle yellow"
                  aria-hidden="true"
                ></i>
                <div
                  class="transferstatustxt"
                  v-bind:class="props.formattedRow[props.column.field] === 'Etl-Failed' || props.formattedRow[props.column.field] === 'Partial'  ? 'yellow' : props.formattedRow[props.column.field] === 'Failed' ? 'red' : ''"
                >{{props.formattedRow[props.column.field]}}</div>
              </a>
            </div>
            <!-- <div class="btnbigquerrywrp" v-if="props.column.field == 'bigquerry'">
              <button class="btn btnbigquerry btn-sm" @click="openexportbgPopuop (props.row)"></button>
            </div>-->
            <span
              v-else-if="props.column.field !== 'name' && props.column.field !== 'Re_Run'"
            >{{props.formattedRow[props.column.field]}}</span>
            <div class="reRun statusLoader" v-if="props.column.field == 'Re_Run'">
              <a class="btn btn-sm" @click="reRun(props)">
                <i class="fa fa-repeat green" aria-hidden="true"></i>
                <div class="transferstatustxt">Re-Run</div>
              </a>
              <!-- <span v-if="props.formattedRow[props.column.field] === 'in-progress'">
                <i class="fa fa-hourglass-half green" aria-hidden="true"></i>
                <b>In-Progress</b>
              </span>
              <span v-if="props.formattedRow[props.column.field] === 'Completed'">
                <i class="fa fa-check-circle green" aria-hidden="true"></i>
                <b>Completed</b>
              </span>-->
            </div>
          </div>
        </template>
        <!-- <template slot="table-row" slot-scope="props">
          <div class="viewrepottbuttonwrapper" v-if="props.column.field == 'name'">
            <a class="viewmodellink" href="javascript:"  @click="viewreportbuttonClick(props.row)">
              {{props.formattedRow[props.column.field]}}
            </a>
          </div>

          <span class="btnbigquerrywrp" v-if="props.column.field == 'bigquerry'">
            <button class="btn btnbigquerry btn-sm" @click="openexportbgPopuop (props.row)"></button>
          </span>
          <span v-if="props.column.field !== 'name'">
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        -->
      </vue-good-table>
    </section>
  </div>
</template>
<script>
/*eslint-disable */
import $ from 'jquery'
var jQuery = $
// Require needed datatables modules
import VueGoodTable from '../../../node_modules/vue-good-table/src/components/Table.vue'
import 'vue-good-table/dist/vue-good-table.css'
// import Simplert from 'vue2-simplert-plugin'
// var moment = require('moment')
var loaddata = []
export default {
  name: 'weeklytrans',
  components: {
    VueGoodTable,
  },
  data () {
    return {
      rows: loaddata,
      dspopup: false,
      dataStatusPopData: [],
      rerun_allow: false,
      columns: [
        {
          label: 'Client',
          field: 'Client',
          type: 'text',
          html: false,
          filterable: false,
          width: '390px',
        },
        {
          label: 'Market',
          field: 'Market',
          type: 'text',
          html: false,
          filterable: false,
          sortable: true,
        },
        {
          label: 'Week Commencing',
          field: 'Week_Commencing',
          html: true,
          filterable: false,
          thClass: 'add-sorting-icon',
          sortable: true,
          width: '100px',
        },
        {
          label: 'Global Data Status',
          field: 'Global_Data_Status',
          type: 'text',
          html: false,
          filterable: false,
          width: '200px',
        },
        {
          label: 'Availability',
          field: 'Availability',
          type: 'text',
          html: false,
          filterable: false,
          width: '200px',
        },
        {
          label: 'Last Run Date',
          field: 'Last_Run_Date',
          type: 'html',
          html: true,
          tdClass: 'status',
          thClass: 'status',
          width: '120px',
        },
        {
          label: 'Re-Run',
          field: 'Re_Run',
          type: 'text',
          html: false,
          filterable: false,
          width: '200px',
          hidden: this.rerun_allow,
        }
        // {
        //   label: 'Export to bigquerry',
        //   field: 'bigquerry',
        //   html: true,
        //   width: '160px',
        //   tdClass: 'text-center'
        // }
      ],
    }
  },
  mounted () {
    // this.$root.$on("DisplayJob", () => {
    //   this.filterfilldatatable();
    // });
    // var self = this;
    // document.body.addEventListener("keyup", e => {
    //   if (e.keyCode === 27) {
    //     self.$Simplert.close();
    //   }
    // });
    // this.captureResponce();
    this.$root.$on('FilterWeekly', () => {
      this.loadDatatoTable()
    })
    this.loadDatatoTable()
  },
  computed: {
    //
  },
  watch: {
    //
  },
  created: function () {
    //
  },
  methods: {
    reRun (obj) {
      var self = this
      console.log('obj ==== >>>> ', obj)
      let dataobj = obj.row
      if (dataobj.Client !== 'matalan') {
        this.marketerrror()
        return false
      }
      var rerundata = {
        client: dataobj.Client,
        market: dataobj.Market,
        'week_commencing': dataobj.Week_Commencing,
        'transfer_id': dataobj.transfer_id
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/VoyagerWeeklyExportsHandler',
        data: JSON.stringify(rerundata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // $('.dataspinner').show()
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.$pingpong.hideloader()
            self.displaypopuperr()
          }
          // data = JSON.parse(data['json-data'])
          self.displaypopup()
          self.$pingpong.hideloader()
          return data

        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        },
      })
    },
    loadDatatoTable () {
      var self = this
      var datas
      if (
        window.localStorage.getItem('client') !== null &&
        window.localStorage.getItem('market') !== null
      ) {
        datas = {
          client: window.localStorage.getItem('client'),
          market: window.localStorage.getItem('market'),
          user_id: window.localStorage.getItem('user'),
        }
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/voyagerweeklydatatransferstatus',
        data: JSON.stringify(datas),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // $('.dataspinner').show()
          self.isLoadingcompo = false
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.$pingpong.hideloader()
            self.displaypopuperr()
          }
          // self.rerun_allow = data.re_run_access === true ? false : true
          if (data.re_run_access === false) {
            self.$refs.datatransferstatus.$set(self.columns[6], 'hidden', true)
          } else if (data.re_run_access === true) {
            self.$refs.datatransferstatus.$set(self.columns[6], 'hidden', false)
          }
          data = JSON.parse(data['json-data'])
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          console.log(data)
          self.rows = data
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        },
      })
    },
    onSortChange (params) {
      setTimeout(function () {
        var elems = document.querySelectorAll(".vgt-left-align.add-sorting-icon");
        [].forEach.call(elems, function (el) {
          el.classList.remove("add-sorting-icon");
        });
      }, 1)
    },
    popuponClose (e) {
      //
      this.dspopup = false
      console.log(e)
    },
    closeexportBigQuryPopup () {
      this.dspopup = false
      jQuery('.highlitetr').removeClass('highlitetr')
    },
    openDtdetails (rowObj, evt) {
      var self = this
      let bsobj = rowObj
      this.currentShareJob = bsobj.transfer_id
      console.log(evt)
      evt.target.parentNode.parentNode.parentNode.parentNode.parentElement.classList.add(
        'highlitetr',
      )
      var DataTranferD = JSON.stringify({ transfer_id: bsobj.transfer_id, client: bsobj.Client })
      // this.$refs.datatransferstatus.classList.add("active")
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerGetDataSource',
        data: DataTranferD,
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey'),
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          if (
            data.statusCode !== 200 ||
            data.statusCode === undefined ||
            data === undefined
          ) {
            self.displaypopuperr()
          }
          data = JSON.parse(data['json-data'])
          console.log(data)
          self.displayDataStatusPopup(data)
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.closeexportBigQuryPopup()
          self.displaypopuperr()
        },
      })
    },
    displaypopup () {
      let obj = {
        title: 'Re-Run in-progerss',
        message: 'Re-Run in-progerss',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
      }
      this.$Simplert.open(obj)
    },
    displayDataStatusPopup (ds) {
      let dataStatus = ds
      this.dspopup = true
      this.dataStatusPopData = dataStatus
      this.$refs.DataStatuspop.classList.add('active')
    },
    displaypopuperr () {
      let obj = {
        title: 'Data Error',
        message: 'Please raise a Yammer message support.',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    },
    marketerrror () {
      let obj = {
        title: 'Market not supported',
        message: 'Re-Run feature is currently not supported for this market.',
        type: 'error',
        customClass: 'error',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close',
      }
      this.$Simplert.open(obj)
    }
  },
}
</script>
<style lang='scss' scoped>
.reRun.statusLoader span {
  position: relative;
  display: block;
  width: 100%;
}

.reRun.statusLoader span b {
  display: block;

  font-weight: normal;
  text-align: center;
  /* margin: 0 -59%; */
  width: 100%;
  background: none;
  font-size: 12px;
}
.transferstatustxt {
  text-decoration: underline;
  font-weight: 600;
  color: #789f00;
}
.yellow {
  color: #fcc400;
}
.modelpopContainer.exportBigQuryPopup table {
  margin-top: 90px;
  margin: 90px auto 25px auto;
  width: 95%;
  td,
  th {
    width: 25%;
    padding: 5px;
    border: 1px solid #e6e6e6;
    text-transform: capitalize;
  }
  th {
    background-color: #e6e6e6;
  }
  th.DsStatus,
  td.DsStatus {
    text-align: center;
  }
}
.settingPopup {
  position: absolute;
  width: 100px;
  top: -9px;
  right: -26px;
  border: 1px solid #232323;
  padding: 10px;
  background: RGBA(0, 0, 0, 0.6);
  transition: all 0.5s linear;
  height: 52px;
  z-index: 99;
  display: none;
  text-align: center;

  .closebtn {
    font-weight: 700;
    color: #fff;
    /* text-shadow: 0 1px 0 #fff; */
    position: absolute;
    top: -10px;
    right: -10px;
    display: inline-block;
    background: #000;
    border-radius: 100px;
    padding: 0px 6px;
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }
}

.settingPopup.active {
  height: 60px;
  width: 110px;
  display: block;
  transition: all 0.2s linear;
}

.btnbigquerrywrp {
  text-align: center;
  display: block;
}

.btnbigquerry {
  background-image: url('/static/img/bigquery.svg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
}

.td-center {
  text-align: center;
}

.good-table td,
.good-table th {
  vertical-align: middle !important;
}

.table > caption + thead > tr:first-child > td,
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > td,
.table > thead:first-child > tr:first-child > th {
  border-top: 1px solid #ddd;
}

table.table-bordered th:last-child,
table.table-bordered td:last-child {
  border-right-width: 1px;
}

table.table.table-bordered.condensed th span {
  text-transform: uppercase;
  text-indent: inherit;
  white-space: nowrap;
}

td.vue-button span:after {
  content: '\F06E';
  display: inline-block;
  width: 10px;
  height: 10px;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 20px;
  margin-left: 15px;
  position: relative;
  top: 2px;
  cursor: pointer;
}

.viewreportbutton {
  position: absolute;
  right: 0px;
  top: -4px;
  bottom: auto;
  margin: auto;
}

.hasbuttonheading span {
  display: block;
  margin-left: 50px;
}

.hideThforbutton {
  display: table-column;
  border-collapse: collapse;
}

.viewrepottbuttonwrapper {
  display: table-cell;
  padding: 0;
  margin: 0;
  vertical-align: middle;
}

th.line-numbers {
  vertical-align: middle !important;
}

.vgt-left-align {
  vertical-align: middle !important;
}

.expotbgheading {
  width: 40%;
  max-width: 300px;
  float: left;
}

.expotbgjobname {
  width: 30%;
  margin: 20px 0 20px 20px;
  font-size: 20px;
}

.sharejobid {
  width: 60%;
  margin: 20px 0 20px 20px;
  font-size: 18px;
}

.exportBqCheckbox .checkbox label {
  margin-left: 20px;
  user-select: none;
  font-size: 14px;
  line-height: 30px;
}

.exportBqCheckbox .checkbox input {
  margin-left: 20px !important;
  line-height: 30px;
  margin-top: 8px;
}

.btnexporttobigqwrapper {
  text-align: right;
  margin-right: 60px;
  margin-top: 60px;
}

.modelpopContainer.exportBigQuryPopup {
  width: 50vw;
  max-height: 30vw;
  min-height: 250px;
  min-width: 350px;
  position: relative;
  height: auto;
}

.exportBqCheckbox {
  margin-top: 50px;
}

.exportBigQuryPopupWrapper,
.ShareModelPopupWrapper {
  display: none;
}

.exportBigQuryPopupWrapper.active,
.ShareModelPopupWrapper.active {
  display: block;
}

.exportBqCheckbox .error {
  margin-left: 21px;
  user-select: none;
}
</style>
<style lang="scss"
       scoped>
.settingsDel {
  display: none;
}

a.viewmodellink {
  font-weight: 500;
  color: #000;
  margin-bottom: 1px;
  text-decoration: underline;
  display: inline-block;
  max-width: 80%;
}

a.viewmodellink:hover,
a.viewmodellink:active,
a.viewmodellink:focus {
  font-weight: 500;
  color: #444;
  margin-bottom: 1px;
  border-bottom: none;
}
</style>
<style>
th.vgt-left-align.sorting {
  cursor: pointer;
}

th.vgt-left-align.sorting.sorting-desc::after,
th.vgt-left-align.sorting.sorting-asc::after,
.add-sorting-icon::after {
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #9fc54c;
  margin-left: 10px;
}

th.vgt-left-align.sorting.sorting-desc::after,
.add-sorting-icon::after {
  content: '\f077';
}

th.vgt-left-align.sorting.sorting-asc::after {
  content: '\f078';
}
</style>
<style lang="scss"
       scoped>
.settingPopup.active .settingsBtn {
  padding: 7px 10px;
  font-size: 26px;
  margin-right: 2px;
  line-height: 27px;
}

.settingPopup.active button {
  margin: 0 4px;
}

.settingPopup.active {
  width: 125px;
  padding-top: 8px;
}
</style>
<style scoped>
.statusLoader i {
  font-size: 24px;
}

.statusLoader .statusLoaderover {
}

.statusLoader {
  text-align: center;
  display: table-cell;
  padding: 0;
  vertical-align: middle;
  position: relative;

  transition: all 2s ease;
}

.statusLoaderover {
  transition: all 2s ease;
}

.statusLoader:hover .statusLoaderover {
  display: block;
  position: absolute;
  left: 0%;
  top: 8px;
  background-color: rgba(68, 68, 68, 0.9);
  color: #fff;
  width: 100%;
  line-height: 1.7em;
  transition: all 2s ease;
  border-radius: 5px;
}

.yellow {
  color: #e2b500;
}

.ShareModelPopupWrapper.active .checkbox {
  width: 40%;
  display: inline-block;
}

.ShareModelPopupWrapper.active .exportBqCheckbox {
  margin-top: 10px;
}

.ShareModelPopupWrapper.active .sharejobid {
  color: #9fc54c;
}

.checkbox.shareselectAll label {
  font-weight: bold;
}

.shareselectbtn {
  margin-left: 19px;
  margin-bottom: 10px;
}

.ShareModelPopupWrapper .btnexporttobigqwrapper {
  text-align: right;
  margin-right: 15px;
  margin-top: 0;
  margin-bottom: 20px;
}
</style>
<style>
th.vgt-left-align.status.sorting {
  text-align: center;
}

.vgt-selection-info-row__actions.vgt-pull-right {
  position: absolute;
  right: 0;
  top: -68px;
}

th.vgt-checkbox-col input[type='checkbox'] {
  margin: 0;
  padding: 0;
  margin-left: 6px;
}

.vgt-selection-info-row {
  background: #dcdfe6 !important;
  color: #444 !important;
}

.btn-red {
  background-color: #b40000 !important;
  border: none !important;
}

.btn-red.active.focus,
.btn-red.active:focus,
.btn-red.active:hover,
.btn-red.hover,
.btn-red:active,
.btn-red:hover {
  border-color: #b40000 !important;
  background-color: #b40000 !important;
  outline: none !important;
  opacity: 0.9;
}
.highlitetr {
  background-color: #fff9d9;
}
</style>



// WEBPACK FOOTER //
// DataTranferStatus.vue?1ba1bc25